<template>
  <div v-if="loggedIn">
    <form>
        <div class="field is-horizontal">
          <div class="field has-addons">
            <div class="control">
              <input class="input" type="text" v-model="name" maxlength="100"
                  placeholder="Search Location Name" v-on:keydown.enter.prevent="doSearch">
            </div>
            <div class="control">
              <button
                class="button is-primary"
                type="button"
                @click="doSearch">
                  <font-awesome-icon :icon="['fal', 'search']"/>
              </button>
            </div>
          </div>
        </div>
    </form>
  </div>

</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faSearch,
} from '@fortawesome/pro-light-svg-icons';

library.add(
  faSearch,
);
export default {
  data() {
    return {
      name: null,
      searchSource: 'advancedSearch',
    };
  },
  computed: {
    loggedIn() {
      return !(this.$store.state.user == null);
    },
  },
  methods: {
    doSearch() {
      const { query } = this.$route;

      if (query.name === this.name) {
        return;
      }

      const target = {
        name: 'locationSearch',
        query: {
          searchSource: this.searchSource,
          name: this.name.trim(),
        },
      };
      this.$router.push(target);
      this.resetField();
    },
    resetField() {
      this.name = null;
    },
  },
};

</script>

<style lang="sass" scoped>
  .button
    height: 25px
  .navbar-profile
   display: flex
   cursor: pointer
  .input
    min-width: 400px
  .icon
    justify-content: center
    align-items: center
    margin-left: .5em
  .profile-menu
    background: #fff
    -webkit-box-shadow: 0 4px 8px -3px #aaa
    box-shadow: 0 4px 8px -3px #aaa
    margin-top: 1em
    padding: 1em
  .flex-box
    display: flex
    flex-wrap: wrap
  .flex-item
</style>
<!-- padding: 0.25em -->
